<template>
  <b-modal 
    id="modal-confirm-set-home-page"
    header-class="align-items-center px-20 py-15"
    body-class="p-20"
    footer-class="px-20 py-15"
  >
    <template #modal-header>
      <div class="modal-title">
        <span class="fs-db-28">
          {{ $t('engine.managePage.setHome.lblTitle',languageEngine) }}
        </span>
      </div>
      <div
        id="close-modal-confirm-set-home-page"
        type="button"
        class="close-modal"
        aria-label="Close"
        @click="close()"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        {{ $t('engine.managePage.setHome.lblText1',languageEngine) }} <span class="text-primary">{{namePage}}</span> {{ $t('engine.managePage.setHome.lblText2',languageEngine) }} ?
      </div>
    </template>
    <template #modal-footer>
      <b-button variant="blue" @click.prevent="confirm()">
        <i class="far fa-check"></i> 
        {{ $t('engine.managePage.setHome.lblSave',languageEngine) }}
      </b-button>
      <b-button variant="default" @click="close()">
        <i class="far fa-times"></i>  
        {{ $t('engine.managePage.setHome.lblCancel',languageEngine) }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  props: ['namePage'],
  methods: {
    close() {
      this.$emit('clear');
      this.$bvModal.hide("modal-confirm-set-home-page");
    },
    confirm() {
      this.$emit('confirmed');
      this.$bvModal.hide("modal-confirm-set-home-page");
    }
  },
}
</script>